import { z } from 'zod';

import type { IdAdvertiserDto } from '@/services/ws-selfbooking/src/main/resources/rest-api';

import type { createCampaignCreateSchema } from './schema.ts';

export interface CampaignCreateFormRouteParams {
  advertiserId?: IdAdvertiserDto;
}

export enum CampaignCreateFormSearchKey {
  ADVERTISER_ID = 'advertiserId',
}

export interface CampaignCreateFormSearchParams {
  [CampaignCreateFormSearchKey.ADVERTISER_ID]?: IdAdvertiserDto;
}

export const campaignCreateFormRouterSearchParamsSchema = z.object({
  [CampaignCreateFormSearchKey.ADVERTISER_ID]: z.string().optional(),
});

export type FormValues = z.input<ReturnType<typeof createCampaignCreateSchema>>;
export type FormSubmitValues = z.output<ReturnType<typeof createCampaignCreateSchema>>;
